import GetLoading from "../../share/getLoading";
import { useEffect, useState } from "react";
import {
  PlusCircleOutlined,
  CloseOutlined,
  PrinterOutlined,
  EditOutlined,
  FilterOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import {
  Table,
  Modal,
  Button,
  Form,
  Input,
  DatePicker,
  Select,
  Space,
  Row,
  Col,
  Tag,
  Popconfirm,
  Checkbox,
} from "antd";
import "../../styles/Home-module.css";
import { request } from "../../share/request";
import { getTageStyle } from "../../share/getStatusContent";
import { formateDateClient } from "../../share/helper";
import { openNotification } from "../../share/message";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import * as FileSaver from "file-saver";
import dayjs from "dayjs";
import ExcelJS from "exceljs";
import PatientForm from "../AnknomphiemPatient/anknomphiem_patient";
import {
  boxHeader,
  boxHeaderTag,
  boxHeaderTagText,
} from "../../styles/boxShadow";
import useOrganizationImage from "../../share/GetImageOrg";
import FilterDate from "../../share/FilterDate";
import CreatePopconfirm from "../../share/CreatePopconfirm";
const WeekendCaseReport = () => {
  const userProfile = getCurrentUser();
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isOpenModel, setOpenModel] = useState(false);
  const [list, setList] = useState([]);
  const [listToExcelFilter, setListToExcelFilter] = useState([]); // for excel filter
  // get list
  const [currentPage, setCurrentPage] = useState(null);
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [sickday, setSickday] = useState("");
  const [dateIn, setDateIn] = useState("");
  const [dateOut, setDateOut] = useState("");
  const [diagnosis, setDiagnosis] = useState(""); //
  const [severe_disease, setSevereDisease] = useState(false);
  const [other, setOther] = useState("");

  const [list_province, setListProvince] = useState([]);
  const [list_city, setListCity] = useState([]);
  const [list_com, setListCom] = useState([]);
  const [list_village, setListVillage] = useState([]);
  const [id, setId] = useState("");
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [com, setCom] = useState("");
  const [village, setVillage] = useState("");
  const [proCode, setProCode] = useState(null);
  const [cityCode, setCityCode] = useState(null);
  const [comCode, setComCode] = useState(null);
  const [villageCode, setVillageCode] = useState(null);
  const [year_number, setYearlyNumber] = useState(new Date().getFullYear());

  const [openModel_Filter, setOpenModel_Filter] = useState(false);
  const [list_weekly, setListWeekly] = useState([]);
  const [weekly, setWeekly] = useState("");
  const LogoPath = useOrganizationImage();
  // --- model filter ----
  const [patientIN, setPatientIN] = useState(false);
  const [patientOut, setPatientOut] = useState(false);
  const [patientSer_illenss, setPatient_Ser_illeness] = useState(false);
  const [patientMil_illenss, setPatient_Mil_illeness] = useState(false);
  // --- end model filter ----
  // download to excel file
  const [list_excel, setListExcel] = useState([]);
  // -----------------  permisstion page --------------------
  const userPermission = getPermission();
  const weeklyReportValue = userPermission.find(
    (permission) => permission.pagename === "caseweekendreport"
  ) || { add: 0, edit: 0, deleted: 0 };
  const {
    add: addvalue,
    edit: Editvalue,
    deleted: deletevalue,
    print: printvalue,
  } = weeklyReportValue;
  // -----------------  end permisstion page --------------------
  const [totalPage, setTotalPages] = useState("");
  const [objFilter, setObjFilter] = useState({
    year_number: year_number,
    weekly: "",
    page_number: 1,
    page_size: 10,
    org_code: userProfile.org_code,
    patientIN: false,
    patientOut: false,
    patientSer_illenss: false,
    patientMil_illenss: false,
    date_start: null,
    date_end: null,
  });

  useEffect(() => {
    console.log("param on effect: ", objFilter);
    getList(objFilter);
  }, []);

  const onChangePage = async (page) => {
    setCurrentPage(page);
    try {
      setLoadingSpin(true);
      var objTmp = {
        ...objFilter,
        page_number: page, // Update the correct property `page_number`
      };
      await new Promise((resolve) => setTimeout(resolve, 400));
      setObjFilter(objTmp); // Ensure this happens before calling `getList`
      getList(objTmp); // Pass the updated filter to `getList`
    } catch (error) {
      console.error("Error changing page:", error);
    } finally {
      setLoadingSpin(false);
    }
  };

  const getList = async (ParamObjFilter) => {
    try {
      setLoading(true); // Start loading

      // Construct query parameters dynamically based on `ParamObjFilter` or default values
      const params = new URLSearchParams({
        year_number: ParamObjFilter.year_number, // Optional value
        weekly: ParamObjFilter.weekly, // Optional value
        page_number: ParamObjFilter.page_number, // Correct the `page_number`
        page_size: ParamObjFilter.page_size, // Optional value
        org_code: ParamObjFilter.org_code, // Optional value
        patientIN: ParamObjFilter.patientIN, // Optional value (boolean)
        patientOut: ParamObjFilter.patientOut, // Optional value (boolean)
        patientSer_illenss: ParamObjFilter.patientSer_illenss, // Optional value (boolean)
        patientMil_illenss: ParamObjFilter.patientMil_illenss, // Optional value (boolean)
        date_start: ParamObjFilter.date_start, // Optional value
        date_end: ParamObjFilter.date_end, // Optional value
      });

      // Send the GET request
      const res = await request("casereportweekend?" + params, "get", {});
      console.log("Query Params:", params.toString());
      console.log("Response from casereportweekend:", res);

      // Simulate delay (optional)
      await new Promise((resolve) => setTimeout(resolve, 400));

      // Check if the response exists and set the data accordingly
      if (res) {
        setList(Array.isArray(res.list) ? res.list : []);
        setListProvince(res.list_province || []);
        setListWeekly(res.list_weekly || []);
        setTotalPages(res.countpage); // Handle `countpage` safely
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // End loading
    }
  };
  const getList_toexcel_fitler = async (ParamObjFilter) => {
    try {
      const params = new URLSearchParams({
        year_number: ParamObjFilter.year_number || "",
        weekly: ParamObjFilter.weekly || "",
        org_code: ParamObjFilter.org_code || "",
        patientIN: ParamObjFilter.patientIN || "",
        patientOut: ParamObjFilter.patientOut || "",
        patientSer_illenss: ParamObjFilter.patientSer_illenss || "",
        patientMil_illenss: ParamObjFilter.patientMil_illenss || "",
        date_start: ParamObjFilter.date_start || "",
        date_end: ParamObjFilter.date_end || "",
      });

      const res = await request("casereportweekendfilter?" + params, "get", {});

      const data = Array.isArray(res?.list) ? res.list : [];
      setListToExcelFilter(data); // Update state for external use if needed
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const { Option } = Select;
  const columns = [
    {
      key: "id",
      title: "ល.រ",
      dataIndex: "id",
      render: (text, record, index) => {
        return (currentPage - 1) * 10 + index + 1;
      },
    },

    {
      key: "name_kh",
      title: "ឈ្មោះ",
      dataIndex: "name_kh",
    },

    {
      key: "age",
      title: "អាយុ",
      dataIndex: "age",
      render: (record) => {
        return (
          <div>
            <Tag>{record}</Tag>
          </div>
        );
      },
    },
    {
      key: "gender",
      title: "ភេទ",
      dataIndex: "gender",
      render: (value) => {
        return <Tag>{value}</Tag>;
      },
    },
    {
      key: "village_name_khmer",
      title: (
        <Tag
          color="#108ee9"
          style={{ borderRadius: 50, paddingLeft: 10, paddingRight: 10 }}
        >
          {"ខេត្ត"}
        </Tag>
      ),
      dataIndex: "province_name_khmer",
      render: (record) => {
        return (
          <div>
            <Tag>{record}</Tag>
          </div>
        );
      },
    },

    // {
    //   key: "com_name_khmer",
    //   title: (
    //     <Tag
    //       color="#108ee9"
    //       style={{ borderRadius: 50, paddingLeft: 10, paddingRight: 10 }}
    //     >
    //       {"ឃុំ"}
    //     </Tag>
    //   ),
    //   dataIndex: "com_name_khmer",
    // },
    // {
    //   key: "city_name_khmer",
    //   title: (
    //     <Tag
    //       color="#108ee9"
    //       style={{ borderRadius: 50, paddingLeft: 10, paddingRight: 10 }}
    //     >
    //       {"ស្រុក"}
    //     </Tag>
    //   ),
    //   dataIndex: "city_name_khmer",
    // },
    // {
    //   key: "province_name_khmer",
    //   title: (
    //     <Tag
    //       color="#108ee9"
    //       style={{ borderRadius: 50, paddingLeft: 10, paddingRight: 10 }}
    //     >
    //       {"ខេត្ត"}
    //     </Tag>
    //   ),
    //   dataIndex: "province_name_khmer",
    // },
    {
      key: "date_sickday",
      title: (
        <div>
          <Tag>ថ្ងៃចេញរោគសញ្ញា</Tag>
        </div>
      ),
      dataIndex: "date_sickday",
      render: (value) => {
        return (
          <div>
            <Tag color="green">{formateDateClient(value)}</Tag>
          </div>
        );
      },
    },
    {
      key: "date_in",
      title: (
        <div>
          <Tag>ថ្ងៃចូលពេទ្យ</Tag>
        </div>
      ),
      dataIndex: "date_in",
      render: (value) => {
        return (
          <div>
            {" "}
            <Tag color="magenta">{formateDateClient(value)}</Tag>
          </div>
        );
      },
    },
    {
      key: "date_out",
      title: (
        <div>
          <Tag>ថ្ងៃចេញពេទ្យ</Tag>
        </div>
      ),
      dataIndex: "date_out",
      render: (value) => {
        return (
          <div>
            {" "}
            <Tag color="magenta">{formateDateClient(value)}</Tag>
          </div>
        );
      },
    },
    {
      key: "diagnosis",
      title: (
        <div>
          <Tag>រោគសញ្ញា</Tag>
        </div>
      ),

      render: (item) => {
        return (
          <>
            <Space>
              {item.diagnosis}
              <Tag color={`${!item.severe_disease == 0 ? "red" : "green"} `}>
                {item.severe_disease == 0 ? "ស្រាល" : "ធ្ងន់ធ្ងរ"}
              </Tag>
            </Space>
          </>
        );
      },
    },
    {
      key: "other",
      title: (
        <div>
          <Tag>ផ្សេងៗ</Tag>
        </div>
      ),
      dataIndex: "other",
    },
    {
      key: "create_date",
      title: (
        <div>
          <Tag>ថ្ងៃបង្កើត</Tag>
        </div>
      ),

      render: (item, index) => {
        return (
          <div>
            <Tag color="purple">{formateDateClient(item.create_date)}</Tag>
            <Tag color="green" style={{ marginTop: 2 }}>
              {item.week_name}
            </Tag>
          </div>
        );
      },
    },
    {
      key: "create_by",
      title: (
        <div>
          <Tag>បង្កើតដោយ</Tag>
        </div>
      ),
      dataIndex: "create_by",
      render: (value, index) => {
        return <Tag color="purple">{value}</Tag>;
      },
    },
    {
      key: "action",
      title: (
        <div>
          <Tag>សកម្មភាព</Tag>
        </div>
      ),
      dataIndex: "action",
      render: (value, item, index) => {
        return (
          <div>
            <Space key={index}>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleOpenEdit(item)}
                disabled={!Editvalue}
              />

              <Popconfirm
                placement="topRight"
                title={"Delete Item"}
                description={"Do you want to delete this item?"}
                okText={"Yes"}
                cancelText="No"
                onConfirm={() => handleDeleteRecord(item)}
              >
                <Button
                  disabled={!deletevalue}
                  danger
                  type="primary"
                  icon={<CloseOutlined />}
                />
              </Popconfirm>
            </Space>
          </div>
        );
      },
    },
  ];
  const handleDeleteRecord = async (item) => {
    try {
      setLoadingSpin(true);
      const data = { id: item.id };
      const res = await request(`casereportdeleterecord`, "put", data);
      if (res) {
        openNotification("success", "Delete Record", res.message);
        getList(objFilter);
      }
    } catch (error) {
    } finally {
      setLoadingSpin(false);
    }
  };
  const onOpenModel = () => {
    setName("");
    setAge("");
    setGender("");
    setProCode("");
    setCityCode("");
    setComCode("");
    setVillageCode("");
    setSickday("");
    setDateIn("");
    setDateOut("");
    setDiagnosis("");
    setOther("");
    setId(null); // Reset id if necessary
    setProvince("");
    setCity("");
    setCom("");
    setVillage(""); // Reset city if necessary
    setWeekly("");

    setSickday(dayjs().format("YYYY-MM-DD"));
    setDateIn(dayjs().format("YYYY-MM-DD"));
    setDateOut(dayjs().format("YYYY-MM-DD"));
    setOpenModel(true);
  };
  const handleOpenEdit = (record) => {
    // `record` is the row or data entry you want to edit

    // Set the current data to the form fields for editing
    setId(record.id);
    setName(record.name_kh);
    setAge(record.age);
    setGender(record.gender);
    setProCode(record.province_id);
    setCityCode(record.city_id);
    setComCode(record.commun_id);
    setVillageCode(record.village_id);
    setSickday(record.date_sickday);
    setDateIn(record.date_in);
    setDateOut(record.date_out);
    setDiagnosis(record.diagnosis);
    setOther(record.other);
    setProvince(record.province_name_khmer);
    setCity(record.city_name_khmer);
    setCom(record.com_name_khmer);
    setVillage(record.village_name_khmer);
    setWeekly(record.week_name);
    setSevereDisease(record.severe_disease == 1 ? true : false);
    setOpenModel(true); // This could be a flag to show the edit form
  };

  const onClickProvince = async (value) => {
    // try {
    //   const res = await request("casereportweekend", "get", {});
    //   await new Promise((resolve) => setTimeout(resolve, 400));
    //   console.log("casereportweekend", res);
    //   if (res && Array.isArray(res.list_province)) {
    //     setListProvince(res.list_province); // Set the array correctly
    //   }
    // } catch (error) {}
  };
  const onChangeProvince = async (value) => {
    console.log("onChangeProvince", value);
    setProvince(value);
    setProCode(value);

    // Reset city, commune, and village when province changes
    setCity(""); // Reset city to empty string (or undefined)
    setCom(""); // Reset commune to empty string (or undefined)
    setVillage(""); // Reset village to empty string (or undefined)

    // Also reset the corresponding codes
    setCityCode(null);
    setComCode(null);
    setVillageCode(null);

    // Clear the lists for commune and village when province changes
    setListCity([]);
    setListCom([]);
    setListVillage([]);

    const res = await request("useraddresscity/" + value, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCity) {
      setListCity(res.API_Server_listCity);
    }
    setDisabledComPop(false);
    setDisableVillagePop(false);
  };
  const [disabledComPop, setDisabledComPop] = useState(false);
  const onChangeCity = async (value) => {
    console.log("onChangeCity", value);
    setCityCode(value);
    setCity(value);
    setCom("");
    setVillage("");
    setListCom([]);
    setListVillage([]);
    const res = await request("useraddresscom/" + value, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCom) {
      setListCom(res.API_Server_listCom);
    }
    setDisabledComPop(true);
    setDisableVillagePop(false);
  };
  const onClickCity = async () => {
    console.log("province code is : ", proCode);
    const res = await request("useraddresscity/" + proCode, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCity) {
      setListCity(res.API_Server_listCity);
    }
  };
  const [disabledVillagePop, setDisableVillagePop] = useState(false);
  const onChangeCom = async (value) => {
    setCom(value);
    setComCode(value);
    setVillage("");
    console.log("com code is : ", value);
    const res = await request("useraddressvillage/" + value, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listVillage) {
      setListVillage(res.API_Server_listVillage);
    }
    setDisableVillagePop(true);
  };

  const onChangeVillage = async (value) => {
    console.log("on change village ", value);
    setVillage(value);
    setVillageCode(value);
  };
  const onClickCom = async () => {
    console.log("com code is : ", comCode);
    const res = await request("useraddresscom/" + cityCode, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCom) {
      setListCom(res.API_Server_listCom);
    }
  };
  const onClickVillage = async () => {
    const res = await request("useraddressvillage/" + comCode, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listVillage) {
      setListVillage(res.API_Server_listVillage);
    }
  };
  const onSaveData = async () => {
    try {
      // Check if any field is null or empty
      if (
        !name ||
        !age ||
        !gender ||
        !proCode ||
        !cityCode ||
        !comCode ||
        !villageCode ||
        !sickday ||
        !dateIn ||
        !dateOut ||
        !diagnosis ||
        !other ||
        !weekly
      ) {
        openNotification(
          "error",
          "Error",
          "Please fill in all the required fields."
        );
        return; // Stop the function if validation fails
      }

      // Parse the date fields to compare
      const sickdayDate = new Date(sickday);
      const dateInDate = new Date(dateIn);
      const dateOutDate = new Date(dateOut);

      // Check if sickday is after dateIn or dateOut
      if (sickdayDate > dateInDate || sickdayDate > dateOutDate) {
        openNotification(
          "error",
          "Error",
          "'Sickday' must be before or equal to 'Date In' and 'Date Out'."
        );
        return; // Stop the function if validation fails
      }

      // Check if dateIn is after dateOut
      if (dateInDate > dateOutDate) {
        openNotification(
          "error",
          "Error",
          "'Date In' must be before or equal to 'Date Out'."
        );
        return; // Stop the function if validation fails
      }
      // check date if select
      console.log("sickday", sickday);
      console.log("dateIn", dateIn);
      console.log("dateOut", dateOut);

      const data = {
        id: id,
        name_kh: name,
        age: age,
        gender: gender,
        province_id: proCode,
        city_id: cityCode,
        commun_id: comCode,
        village_id: villageCode,
        date_sickday: dayjs(sickday).format("YYYY-MM-DD"),
        date_in: dayjs(dateIn).format("YYYY-MM-DD"),
        date_out: dayjs(dateOut).format("YYYY-MM-DD"),
        diagnosis: diagnosis,
        severe_disease: severe_disease,
        other: other,
        create_by: userProfile.fullname,
        weekly: weekly,
        org_code: userProfile.org_code,
      };

      let res;
      setOpenModel(false);
      setLoadingSpin(true);
      if (id == null) {
        // Save (insert) new data
        res = await request("casereportweekend", "post", data);
      } else {
        // Update existing data
        res = await request(`casereportweekend`, "put", data);
      }

      if (res) {
        openNotification("success", "Success", res.message);

        // Clear all form fields after successful save
        setName("");
        setAge("");
        setGender("");
        setProCode("");
        setCityCode("");
        setComCode("");
        setVillageCode("");
        setSickday("");
        setDateIn("");
        setDateOut("");
        setDiagnosis("");
        setOther("");
        setId(null); // Reset id if necessary
      }
    } catch (error) {
      openNotification("error", "Error", error);
    } finally {
      setLoadingSpin(false);
      getList(objFilter);
    }
  };

  const handleDateSickDayChange = (date, dateString) => {
    setSickday(dayjs(dateString, "DD/MM/YYYY")); // Store the date as a string in YYYY-MM-DD format
  };

  const handleDateInChange = (date, dateString) => {
    setDateIn(dayjs(dateString, "DD/MM/YYYY"));
  };

  const handleDateOutChange = (date, dateString) => {
    setDateOut(dayjs(dateString, "DD/MM/YYYY"));
  };
  // Change handlers
  const onChangeName = (e) => {
    setName(e.target.value);
  };

  const onChangeAge = (e) => {
    setAge(e.target.value);
  };

  const onChangeGender = (value) => {
    setGender(value); // Assuming the value is the selected gender option
  };

  const onChangeDiagnosis = (e) => {
    setDiagnosis(e.target.value);
  };

  const onChangeOther = (e) => {
    setOther(e.target.value);
  };
  const onChangeWeekly = (e) => {
    setWeekly(e);
  };

  const onChangeWeeklySearch = async (value) => {
    setWeekly(value);
    setCurrentPage(1);
    if (value === undefined) {
      try {
        setLoadingSpin(true);
        var objTmp = {
          weekly: "", // Update the correct property `page_number`
          page_number: 1,
          org_code: userProfile.org_code,
        };
        setObjFilter(objTmp); // Ensure this happens before calling `getList`
        getList(objTmp); // Pass the updated filter to `getList`
      } catch (error) {
        console.error("Error changing page:", error);
      } finally {
        setLoadingSpin(false);
      }
    } else {
      try {
        setLoadingSpin(true);
        var objTmp = {
          ...objFilter,
          page_number: 1,
          weekly: value, // Update the correct property `page_number`
        };

        setObjFilter(objTmp); // Ensure this happens before calling `getList`
        getList(objTmp); // Pass the updated filter to `getList`
      } catch (error) {
        console.error("Error changing page:", error);
      } finally {
        setLoadingSpin(false);
      }
    }
  };
  // Returns the start (Monday) and end (Sunday) date of the given ISO week and year.
  // This function is robust and formats the date in the local timezone to avoid UTC conversion issues.
  function getStartAndEndDateOfWeek(weekNumber, year) {
    // Helper function to format date as YYYY-MM-DD in the local timezone.
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    // Find a day in the target week.
    const simple = new Date(year, 0, 1 + (weekNumber - 1) * 7);
    simple.setHours(0, 0, 0, 0); // Zero out time to avoid DST issues.

    // Convert JS day (0=Sun) to ISO day (1=Mon).
    const dayOfWeek = simple.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    // Find Monday (start of the week).
    const monday = new Date(simple);
    monday.setDate(simple.getDate() - isoDayOfWeek + 1);

    // Find Sunday (end of the week).
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    // Return dates formatted in the local timezone.
    return {
      startDate: formatDate(monday),
      endDate: formatDate(sunday),
    };
  }

  const onHanndleDownloadReport = async () => {
    if (
      weekly == null ||
      weekly === undefined ||
      year_number == null ||
      year_number === undefined
    ) {
      openNotification(
        "error",
        "Canot Download Report",
        "Please select Year and  Weekly Download Report"
      );
    } else {
      const { startDate, endDate } = getStartAndEndDateOfWeek(
        weekly,
        year_number
      );
      console.log("date fo weekeknd: ", getStartAndEndDateOfWeek(29, 2025));
      try {
        setLoadingSpin(true);
        await new Promise((resolve) => setTimeout(resolve, 400));

        // Fetch data to be exported to Excel
        const data = await onExporttoExcel();

        // Ensure data is an array and contains items
        if (!Array.isArray(data) || data.length === 0) {
          console.error("Data is not an array or is empty.", data);
          setLoadingSpin(false);
          openNotification("error", "Error", "No data available for download.");
          return;
        }

        // Load the template Excel file from the public folder
        const templatePath =
          process.env.PUBLIC_URL + "/template/weeklyreport.xlsx";
        const response = await fetch(templatePath);
        const templateArrayBuffer = await response.arrayBuffer();

        // Create a workbook from the template file
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(templateArrayBuffer);

        // Get the 'detail' sheet from the workbook
        const dataSheet = workbook.getWorksheet("detail");
        if (!dataSheet) {
          console.error('Sheet with name "detail" not found in the template.');
          setLoadingSpin(false);
          return;
        }
        // Set the weekly string to cell N10
        dataSheet.getCell("N10").value = `${weekly}`;
        dataSheet.getCell("O10").value = `${weekly}`;
        dataSheet.getCell("P10").value = `${startDate}`;
        dataSheet.getCell("Q10").value = `${endDate}`;
        dataSheet.getCell("A4").value = `${userProfile.org_name_kh}`;
        try {
          console.log("Fetching image from:", LogoPath);

          const response = await fetch(LogoPath, { mode: "cors" }); // Ensure CORS is allowed
          if (!response.ok) {
            throw new Error(
              `Failed to fetch image. Status: ${response.status}`
            );
          }

          const imageBuffer = await response.arrayBuffer(); // Convert to array buffer

          // Add the image to the workbook
          const imageId = workbook.addImage({
            buffer: Buffer.from(imageBuffer), // Convert ArrayBuffer to Buffer
            extension: "png", // Ensure correct image format
          });

          // Add the image to the worksheet
          dataSheet.addImage(imageId, {
            tl: { col: 1, row: 2 },
            ext: { width: 150, height: 150 },
          });

          console.log("Image added successfully!");
        } catch (error) {
          console.error("Error adding image to workbook:", error);
        }

        // Convert the fetched data to an array format (rows)
        const newData = data.map((item) => Object.values(item));

        // Ensure newData is not empty and contains valid column names
        if (newData.length > 0 && Object.keys(data[0]).length > 0) {
          const columns = Object.keys(data[0]).map((key) => ({ name: key }));

          // Append the new data to the existing 'detail' sheet starting from cell A10
          dataSheet.addTable({
            name: "dataTable",
            ref: "A10", // Ensure this is where your table starts
            headerRow: true,
            columns: columns,
            rows: newData,
          });

          // Calculate the last row of the data
          const lastRow = newData.length + 10; // Adjust based on starting row (A10)

          // Hide rows from the last data row + 1 to row 100
          for (let i = lastRow + 1; i <= 200; i++) {
            const row = dataSheet.getRow(i);
            row.hidden = true; // Hide the row
          }
        } else {
          console.error(
            "New data is empty or does not contain valid column names."
          );
          setLoadingSpin(false);
          return;
        }

        // Save the modified workbook as a Blob with XLSX format
        const blob = await workbook.xlsx.writeBuffer();
        const name_report = `Weekly-Report-${weekly}`;
        FileSaver.saveAs(new Blob([blob]), `${name_report}.xlsx`);
        setLoadingSpin(false);
      } catch (error) {
        setLoadingSpin(false);
        console.error("Error during file download:", error);
        openNotification("error", "error", "File can't be downloaded!");
      }
    }
  };
  const onHanndleDownloadReport_by_filter = async () => {
    try {
      setLoadingSpin(true);

      // Fetch data synchronously
      const data_original = await getList_toexcel_fitler(objFilter);

      if (!Array.isArray(data_original) || data_original.length === 0) {
        console.error("Data is not an array or is empty.", data_original);
        setLoadingSpin(false);
        openNotification("error", "Error", "No data available for download.");
        return;
      }

      // Fields to exclude
      const excludeKeys = [
        "create_date",
        "create_by",
        "province_id",
        "city_id",
        "commun_id",
        "village_id",
      ];

      // Transform data
      const transformedData = data_original.map((item, index) => ({
        ...item,
        id: index + 1,
        gender: item.gender, // 'ប្រុស' or 'ស្រី'
        severe_disease:
          item.severe_disease === 1
            ? "ធ្ងន់ធ្ងរ"
            : item.severe_disease === 0
            ? "ស្រាល"
            : "",
        week_name: item.week_name ? `សប្តាហ៍ ${item.week_name}` : "",
        date_sickday: item.date_sickday
          ? dayjs(item.date_sickday).format("DD/MM/YYYY")
          : "",
        date_in: item.date_in ? dayjs(item.date_in).format("DD/MM/YYYY") : "",
        date_out: item.date_out
          ? dayjs(item.date_out).format("DD/MM/YYYY")
          : "",
      }));
      // Create summary
      const summary = {
        ប្រុស: transformedData.filter((item) => item.gender === "ប្រុស").length,
        ស្រី: transformedData.filter((item) => item.gender === "ស្រី").length,
        ធ្ងន់ធ្ងរ: transformedData.filter(
          (item) => item.severe_disease === "ធ្ងន់ធ្ងរ"
        ).length,
        ស្រាល: transformedData.filter((item) => item.severe_disease === "ស្រាល")
          .length,
      };
      const summaryRow =
        "សរុប : " +
        `ប្រុស: ${summary.ប្រុស}, ស្រី: ${summary.ស្រី} ` +
        "         ចំនួនករណី : " +
        `ធ្ងន់ធ្ងរ: ${summary.ធ្ងន់ធ្ងរ}, ស្រាល: ${summary.ស្រាល}`;

      const filteredColumns = Object.keys(transformedData[0]).filter(
        (key) => !excludeKeys.includes(key)
      );

      const columns = filteredColumns.map((key) => ({ name: key }));
      const data = transformedData.map((item) =>
        filteredColumns.map((key) => item[key])
      );

      // Load Excel template
      const templatePath =
        process.env.PUBLIC_URL + "/template/weeklyreport_by_filter.xlsx";
      const response = await fetch(templatePath);
      const templateArrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(templateArrayBuffer);

      const dataSheet = workbook.getWorksheet("detail");
      if (!dataSheet) {
        console.error('Sheet with name "detail" not found in the template.');
        setLoadingSpin(false);
        return;
      }

      dataSheet.getCell("A4").value = `${userProfile.org_name_kh}`;
      dataSheet.getCell("C7").value = `${summaryRow}`;
      // Add logo
      try {
        const logoRes = await fetch(LogoPath, { mode: "cors" });
        if (!logoRes.ok) {
          throw new Error(`Failed to fetch image. Status: ${logoRes.status}`);
        }

        const imageBuffer = await logoRes.arrayBuffer();
        const imageId = workbook.addImage({
          buffer: Buffer.from(imageBuffer),
          extension: "png",
        });

        dataSheet.addImage(imageId, {
          tl: { col: 1, row: 2 },
          ext: { width: 150, height: 150 },
        });
      } catch (error) {
        console.error("Error adding image to workbook:", error);
      }

      // Insert table
      dataSheet.addTable({
        name: `dataTable_${Date.now()}`,
        ref: "A10",
        headerRow: true,
        columns: columns,
        rows: data,
      });

      const blob = await workbook.xlsx.writeBuffer();
      const name_report = `Weekly-Report-ByFilter_${dayjs().format(
        "YYYYMMDD_HHmmss"
      )}`;
      FileSaver.saveAs(new Blob([blob]), `${name_report}.xlsx`);
      setLoadingSpin(false);
    } catch (error) {
      setLoadingSpin(false);
      console.error("Error during file download:", error);
      openNotification("error", "error", "File can't be downloaded!");
    }
  };

  const onExporttoExcel = async () => {
    const params = new URLSearchParams({
      year_number: year_number,
      weekly: weekly,
      org_code: userProfile.org_code,
    });

    await new Promise((resolve) => setTimeout(resolve, 400)); // Simulating delay
    const res = await request(
      "caseweekdownload?" + params.toString(),
      "get",
      {}
    );

    // Ensure res.listdownload is an array
    if (res && Array.isArray(res.listdownload)) {
      const dataArray = res.listdownload; // Use the full array

      // Function to format the date to 'DD-MM-YYYY'
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB"); // 'en-GB' formats to DD-MM-YYYY
      };

      // Create a new array of objects excluding specific fields and formatting the dates
      const filteredData = dataArray.map((item, index) => {
        const {
          create_date,
          create_by,
          province_id,
          city_id,
          commun_id,
          village_id,
          week_name,
          ...filteredItem
        } = item;

        // Format the dates before returning the filtered item
        if (filteredItem.date_sickday)
          filteredItem.date_sickday = formatDate(filteredItem.date_sickday);
        if (filteredItem.date_in)
          filteredItem.date_in = formatDate(filteredItem.date_in);
        if (filteredItem.date_out)
          filteredItem.date_out = formatDate(filteredItem.date_out);
        filteredItem.id = index + 1;
        return filteredItem;
      });

      // Log and return the filtered array for further use if needed
      console.log(
        "Filtered data with formatted dates for export:",
        filteredData
      );
      return filteredData;
    }

    console.error("No valid data received from server.");
    return []; // Return an empty array if no data
  };
  const [patientModel, setpatientModel] = useState(false);
  const onOpenModelanknomphiem_patient = () => {
    setpatientModel(true);
  };

  const onChangeYearReport = (value) => {
    setYearlyNumber(value);
    setCurrentPage(1);
    if (value === undefined) {
      try {
        setLoadingSpin(true);
        var objTmp = {
          year_number: "", // Update the correct property `page_number`
          page_number: 1,
          org_code: userProfile.org_code,
        };
        setObjFilter(objTmp); // Ensure this happens before calling `getList`
        getList(objTmp); // Pass the updated filter to `getList`
      } catch (error) {
        console.error("Error changing page:", error);
      } finally {
        setLoadingSpin(false);
      }
    } else {
      try {
        setLoadingSpin(true);
        var objTmp = {
          ...objFilter,
          page_number: 1,
          year_number: value, // Update the correct property `page_number`
        };

        setObjFilter(objTmp); // Ensure this happens before calling `getList`
        getList(objTmp); // Pass the updated filter to `getList`
      } catch (error) {
        console.error("Error changing page:", error);
      } finally {
        setLoadingSpin(false);
      }
    }
  };

  const onHandleSevereDisease = (e) => {
    setSevereDisease(e.target.checked);
  };

  const onHnadlPatient_in = (e) => {
    setPatientIN(e.target.checked);
  };
  const onHnadlPatient_out = (e) => {
    setPatientOut(e.target.checked);
  };
  const onHandlPatient_Ser_illeness = (e) => {
    setPatient_Ser_illeness(e.target.checked);
  };
  const onHandlPatient_Mil_illeness = (e) => {
    setPatient_Mil_illeness(e.target.checked);
  };
  const handleFilterDateChange = async (dateRange) => {
    const newFilter = {
      ...objFilter,
      patientIN: patientIN,
      patientOut: patientOut,
      patientSer_illenss: patientSer_illenss,
      patientMil_illenss: patientMil_illenss,
      date_start: dateRange.start,
      date_end: dateRange.end,
    };

    setObjFilter(newFilter);
    getList(newFilter);
    setOpenModel_Filter(false);
  };

  const [openDistrict, setOpenDistrict] = useState(false);
  const [openCommune, setOpenCommune] = useState(false);
  const [openVillage, setOpenVillage] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [txtInputDriver, setTxtInputDriver] = useState("");
  const onChangeInputDriver = (e) => {
    setTxtInputDriver(e.target.value);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const data = {
      param_type: openDistrict
        ? "district"
        : openCommune
        ? "commune"
        : openVillage
        ? "village"
        : "",
      param_code: openDistrict
        ? proCode
        : openCommune
        ? cityCode
        : openVillage
        ? comCode
        : "",
      param_value: txtInputDriver,
    };

    const res = await request("casecreateaddress", "post", data);
    if (res) {
      openNotification("success", "Success", res.message);
      setTxtInputDriver("");
    } else {
      openNotification("error", "Error", "Failed to add new entry.");
    }

    setTimeout(() => {
      setConfirmLoading(false);
      setOpenDistrict(false);
      setOpenCommune(false);
      setOpenVillage(false);
    }, 1000);
  };

  const handleCancel_pro = () => {
    setOpenDistrict(false);
    setOpenCommune(false);
    setOpenVillage(false);
    setTxtInputDriver("");
  };
  // Clear input when popconfirm is opened
  useEffect(() => {
    if (openCommune || openDistrict || openVillage) {
      setTxtInputDriver("");
    }
  }, [openCommune, openDistrict, openVillage]);
  return (
    <div>
      <Modal open={patientModel} width={900}>
        <PatientForm />
      </Modal>

      <div className="sprinSave-container">
        {/* Your other components */}
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      <div style={boxHeader}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Space>
            {boxHeaderTagText("តារាងជំងឺប្រចាំសប្តាហ៍")}
            {/* <Input placeholder="Search..." style={{ height: 40 }}></Input> */}
            <Select
              style={{ width: 150, fontWeight: "bold" }}
              className="styleTageStatusForm"
              onChange={onChangeYearReport}
              placeholder="ឆ្នាំ"
              value={year_number}
              allowClear
            >
              <Option value="2022">2022</Option>
              <Option value="2023">2023</Option>
              <Option value="2024">2024</Option>
              <Option value="2025">2025</Option>
              <Option value="2026">2026</Option>
              <Option value="2027">2027</Option>
              <Option value="2028">2028</Option>
              <Option value="2029">2029</Option>
              <Option value="2030">2030</Option>
            </Select>
            <Select
              className="styleTageStatusForm"
              placeholder="សប្តាហ៍"
              style={{ width: 120, fontWeight: "bold" }}
              onChange={onChangeWeeklySearch}
              allowClear={true}
            >
              {list_weekly.map((option) => (
                <Option
                  className="styleTageStatusForm"
                  style={{ fontWeight: "bold" }}
                  key={option.id}
                  value={option.week_name}
                >
                  {option?.week_name || null}{" "}
                </Option>
              ))}
            </Select>
            <Button
              type="primary"
              onClick={() => {
                setOpenModel_Filter(true);
              }}
              icon={<FilterOutlined />}
            />
            <Modal title="ស្វែងរក" open={openModel_Filter} footer={false}>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                {/* First row: ថ្ងៃចូលពេទ្យ & ថ្ងៃចេញពេទ្យ */}
                <div
                  style={{
                    display: "flex",
                    gap: 20,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <Checkbox onChange={onHnadlPatient_in} />
                    <span>ថ្ងៃចូលពេទ្យ</span>
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <Checkbox onChange={onHnadlPatient_out} />
                    <span>ថ្ងៃចេញពេទ្យ</span>
                  </div>
                </div>

                {/* Second row: ជំងឺធ្ងន់ & ជំងឺស្រាល */}
                <div
                  style={{
                    display: "flex",
                    gap: 20,
                    background: "#fde2e2",
                    padding: 10,
                    borderRadius: 6,
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <Checkbox onChange={onHandlPatient_Ser_illeness} />
                    <span>ជំងឺធ្ងន់</span>
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <Checkbox onChange={onHandlPatient_Mil_illeness} />
                    <span>ជំងឺស្រាល</span>
                  </div>
                </div>
              </div>

              <FilterDate
                closeModelFilter={() => setOpenModel_Filter(false)}
                onFilterDateChange={handleFilterDateChange}
              />
            </Modal>
          </Space>
        </div>
        <div style={{ display: "flex" }}>
          <Space>
            <Button
              disabled={!printvalue}
              onClick={onHanndleDownloadReport_by_filter}
              className="buttonstylekhmer"
              type="primary"
              style={{ backgroundColor: "#aa2b00ff", color: "white" }}
              icon={<FileExcelOutlined />}
            ></Button>
            <Button
              disabled={!printvalue}
              onClick={onHanndleDownloadReport}
              className="buttonstylekhmer"
              type="primary"
              icon={<PrinterOutlined />}
            >
              ទាញរបាយការណ៍(Weekly)
            </Button>
            <Button
              disabled={!addvalue}
              onClick={onOpenModel}
              className="buttonstylekhmer"
              type="primary"
              icon={<PlusCircleOutlined />}
            >
              បង្កើតថ្មី
            </Button>
          </Space>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table
            pagination={{
              pageSize: 10,
              total: totalPage,
              current: currentPage,
              onChange: onChangePage,
              // position: ["bottomLeft"], // Set pagination to bottom left
            }}
            columns={columns}
            size="small"
            dataSource={list}
          />
        )}
      </div>
      <Modal
        open={isOpenModel}
        width={900}
        title={id == null ? "បង្កើតថ្មី (New Case)" : "កែប្រែ (Update)"}
        onCancel={() => {
          setOpenModel(false);
        }}
        onClose={() => {
          setOpenModel(false);
        }}
        footer={[
          <Button key="cancel" onClick={() => setOpenModel(false)}>
            បោះបង់ (Cancel)
          </Button>,
          <Button key="ok" type="primary" onClick={() => onSaveData()}>
            {id == null ? "រក្សាទុក (Save)" : "កែប្រែ (Update)"}
          </Button>,
        ]}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ margin: 5, width: 300 }}>
            <Form.Item
              label="ឈ្មោះ (Name)"
              name="name"
              rules={[{ required: true, message: "សូមបញ្ចូលឈ្មោះ!" }]}
            ></Form.Item>
            <Input
              style={{ width: 250, height: 40 }}
              placeholder="បញ្ចូលឈ្មោះ"
              onChange={onChangeName}
              value={name}
            />
            <Form.Item
              label="អាយុ (Age)"
              name="age"
              rules={[{ required: true, message: "សូមបញ្ចូលអាយុ!" }]}
            ></Form.Item>
            <Input
              value={age}
              style={{ width: 250, height: 40 }}
              placeholder="បញ្ចូលអាយុ"
              onChange={onChangeAge}
            />
            <Form.Item
              label="ភេទ (Gender)"
              name="gender"
              rules={[{ required: true, message: "សូមជ្រើសរើសភេទ!" }]}
            ></Form.Item>
            <Select
              placeholder="ជ្រើសរើសភេទ"
              onChange={onChangeGender}
              value={gender}
              style={{ width: 250, height: 40 }}
            >
              <Option value="ប្រុស">ប្រុស</Option>
              <Option value="ស្រី">ស្រី</Option>
            </Select>
          </div>
          <div style={{ margin: 5, width: 300 }}>
            <Form.Item
              label="ខេត្ត (Province)"
              name="province"
              rules={[{ required: true, message: "សូមបញ្ចូលខេត្ត!" }]}
            >
              {" "}
              <Select
                className="styleTageStatusForm"
                placeholder="Select an Province"
                style={{ width: 250 }}
                onClick={onClickProvince}
                onChange={onChangeProvince}
                value={province}
              >
                {list_province.map((option) => (
                  <Option
                    className="styleTageStatusForm"
                    key={option.province_code}
                    value={option.province_code}
                  >
                    {option.province_name_khmer}
                    {/* Replace with the field from your MySQL table */}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="ស្រុក (District)"
              name="district"
              rules={[{ required: true, message: "សូមបញ្ចូលស្រុក!" }]}
            >
              {" "}
              <Select
                value={city}
                className="styleTageStatusForm"
                placeholder="Select an City"
                style={{ width: 250 }}
                onChange={onChangeCity}
                onClick={onClickCity}
                disabled={!list_city.length}
              >
                {list_city.map((option) => (
                  <Option
                    className="styleTageStatusForm"
                    key={option.city_code}
                    value={option.city_code}
                  >
                    {option?.city_name_khmer || null}{" "}
                  </Option>
                ))}
              </Select>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 5,
                  color: !list_city.length ? "#aaa" : "red",
                  pointerEvents: !list_city.length ? "none" : "auto",
                  gap: 5,
                }}
              >
                <PlusCircleOutlined />
                <a
                  onClick={() => {
                    setOpenDistrict(true);
                    setOpenCommune(false);
                    setOpenVillage(false);
                  }}
                  style={{
                    width: 50,
                  }}
                >
                  បង្កើតថ្មី
                </a>
                <CreatePopconfirm
                  disabled={!list_city.length}
                  openPop={openDistrict}
                  caption={"បង្កើតស្រុក (Create District)"}
                  onChangeInputDriver={onChangeInputDriver}
                  handleOk={handleOk}
                  confirmLoading={confirmLoading}
                  handleCancel_pro={handleCancel_pro}
                />
              </div>
            </Form.Item>

            <Form.Item
              label="ឃុំ (Commune)"
              name="commune"
              rules={[{ required: true, message: "សូមបញ្ចូលឃុំ!" }]}
            >
              {" "}
              <Select
                className="styleTageStatusForm"
                placeholder="Select an Commune"
                style={{ width: 250 }}
                onChange={onChangeCom}
                onClick={onClickCom}
                value={com}
                disabled={!disabledComPop}
              >
                {list_com.map((option) => (
                  <Option
                    className="styleTageStatusForm"
                    key={option.com_code}
                    value={option.com_code}
                  >
                    {option?.com_name_khmer || null}{" "}
                  </Option>
                ))}
              </Select>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 5,
                  color: !disabledComPop ? "#aaa" : "red",
                  pointerEvents: !disabledComPop ? "none" : "auto",
                  gap: 5,
                }}
              >
                <PlusCircleOutlined />
                <a
                  onClick={() => {
                    setOpenCommune(true);
                    setOpenVillage(false);
                    setOpenDistrict(false);
                  }}
                  style={{ width: 50 }}
                >
                  បង្កើតថ្មី
                </a>
                <CreatePopconfirm
                  disabled={!disabledComPop}
                  openPop={openCommune}
                  caption={"បង្កើតឃុំ (Create Commune)"}
                  onChangeInputDriver={onChangeInputDriver}
                  handleOk={handleOk}
                  confirmLoading={confirmLoading}
                  handleCancel_pro={handleCancel_pro}
                />
              </div>
            </Form.Item>

            <Form.Item
              label="ភូមិ (Village)"
              name="village"
              rules={[{ required: true, message: "សូមបញ្ចូលភូមិ!" }]}
            >
              {" "}
              <Select
                className="styleTageStatusForm"
                placeholder="Select an Village"
                style={{ width: 250 }}
                onChange={onChangeVillage}
                onClick={onClickVillage}
                value={village}
                disabled={!disabledVillagePop}
              >
                {list_village.map((option) => (
                  <Option
                    className="styleTageStatusForm"
                    key={option.village_code}
                    value={option.village_code}
                  >
                    {option?.village_name_khmer || null}{" "}
                    {/* Replace with the field from your MySQL table */}
                  </Option>
                ))}
              </Select>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 5,
                  color: !disabledVillagePop ? "#aaa" : "red",
                  pointerEvents: !disabledVillagePop ? "none" : "auto",
                  gap: 5,
                }}
              >
                <PlusCircleOutlined />
                <a
                  onClick={() => {
                    setOpenVillage(true);
                    setOpenCommune(false);
                    setOpenDistrict(false);
                  }}
                  style={{ width: 50 }}
                >
                  បង្កើតថ្មី
                </a>
                <CreatePopconfirm
                  disabled={!disabledVillagePop}
                  openPop={openVillage}
                  caption={"បង្កើតភូមិ (Create Village)"}
                  onChangeInputDriver={onChangeInputDriver}
                  handleOk={handleOk}
                  confirmLoading={confirmLoading}
                  handleCancel_pro={handleCancel_pro}
                />
              </div>
            </Form.Item>
          </div>
          <div style={{ margin: 5, width: 300 }}>
            <Form.Item
              label="ថ្ងៃចេញរោគសញ្ញា (Symptom Date)"
              name="symptomDate"
              rules={[
                { required: true, message: "សូមជ្រើសរើសថ្ងៃចេញរោគសញ្ញា!" },
              ]}
            ></Form.Item>
            <DatePicker
              name={sickday}
              value={dayjs(sickday)}
              format="DD/MM/YYYY"
              style={{ width: "100%", height: 40 }}
              onChange={handleDateSickDayChange}
            />
            <Form.Item
              label="ថ្ងៃចូលពេទ្យ (Admission Date)"
              name="admissionDate"
              rules={[{ required: true, message: "សូមជ្រើសរើសថ្ងៃចូលពេទ្យ!" }]}
            ></Form.Item>
            <DatePicker
              name={dateIn}
              value={dayjs(dateIn)}
              format="DD/MM/YYYY"
              style={{ width: "100%", height: 40 }}
              onChange={handleDateInChange}
            />
            <Form.Item
              label="ថ្ងៃចេញពេទ្យ (Discharge Date)"
              name="dischargeDate"
              rules={[{ required: true, message: "សូមជ្រើសរើសថ្ងៃចេញពេទ្យ!" }]}
            ></Form.Item>
            <DatePicker
              name={dateOut}
              value={dayjs(dateOut)}
              format="DD/MM/YYYY"
              style={{ width: "100%", height: 40 }}
              onChange={handleDateOutChange}
            />
            <Form.Item
              label="សប្តាហ៍ទី (Weekend)"
              rules={[{ required: true, message: "សប្តាហ៍ទី (Weekend)" }]}
            >
              <Select
                value={weekly}
                className="styleTageStatusForm"
                placeholder="Select an Weekly"
                style={{ width: 250 }}
                onChange={onChangeWeekly}
              >
                {list_weekly.map((option) => (
                  <Option
                    className="styleTageStatusForm"
                    key={option.id}
                    value={option.week_name}
                  >
                    {option?.week_name || null}{" "}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>

        {/* Symptoms and Other Information */}
        <Row gutter={12}>
          {/* Left Column: Symptoms */}
          <Col span={12}>
            {/* Custom label outside of Form.Item */}
            <div style={{ fontWeight: "bold" }}>
              រោគសញ្ញា (Symptoms) <span style={{ color: "red" }}>*</span>
            </div>
            {/* Form.Item with name for validation */}
            <Form.Item
              name="symptoms"
              rules={[{ required: true, message: "សូមបញ្ចូលរោគសញ្ញា!" }]}
            ></Form.Item>
            {/* Checkbox outside of Form.Item */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                margin: 10,
              }}
            >
              <Checkbox
                checked={severe_disease}
                onChange={onHandleSevereDisease}
              />
              <span style={{ color: "red" }}>ជំងឺធ្ងន់ធ្ងរ</span>
            </div>{" "}
            <Input.TextArea
              value={diagnosis}
              placeholder="បញ្ចូលរោគសញ្ញា"
              rows={2}
              onChange={onChangeDiagnosis}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12}>
            {/* Right Column: Other Info */}
            <Form.Item
              label="ផ្សេងៗ (Other information)"
              name="others"
            ></Form.Item>
            <Input.TextArea
              placeholder="បញ្ចូលព័ត៌មានផ្សេងៗ"
              rows={2}
              value={other}
              onChange={onChangeOther}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};
export default WeekendCaseReport;
